import * as React from 'react'
import { injectIntl, IntlShape } from 'react-intl'
import classNames from 'classnames'
import { RouteComponentProps, withRouter } from 'react-router'
import { BrowserRouter, Link } from 'react-router-dom'
import styles from './TermsAndConditionsLink.module.scss'
import { getRouteWithEnv, TermsAndConditionsRoute } from '../../Routes'
import { CountryCode } from '../../store/DeliveryTracking/types'

interface Props {
  country: string
  intl: IntlShape
}

class TermsAndConditionsLink extends React.Component<RouteComponentProps & Props> {
  render() {
    const { intl: { formatMessage }, history, country } = this.props
    const translate = (id: string, values: any = {}) => formatMessage({ id }, values)
    const redirectCallback = (e: any) => {
      e.preventDefault()
      return history.push(getRouteWithEnv(TermsAndConditionsRoute))
    }

    // todo @zhernosenko: remove that after finishing of tests
    const testFeatureFlag = localStorage.getItem('testFeature')
    let cntr = ''
    if (typeof country !== 'undefined') {
      cntr = country.toUpperCase()
    }
    const haveFeatureFlag = typeof testFeatureFlag === 'string' && testFeatureFlag.includes('terms-and-conditions')
    if (cntr !== CountryCode.Israel && !haveFeatureFlag) {
      return null
    }

    return (
      <BrowserRouter>
        <Link
          to="#"
          onClick={redirectCallback}
          className={classNames(styles.termsAndConditionsLink)}
          title={translate('terms_and_conditions.link_text')}
        >
          {translate('terms_and_conditions.link_text')}
        </Link>
      </BrowserRouter>
    )
  }
}

export default withRouter(injectIntl(TermsAndConditionsLink))
